export default function (value: string) {
  return value || '-'
}
